import {TaskType} from '../constants/dataEnum';

export const ESCAPE_CHAR = {
  QUOTE: {char: '[quote]', string: '"'},
  COMA: {char: '[comma]', string: ','},
};

export const dequote = (value) => {
  let newValue = value;

  if (value && value.includes('"')) {
    newValue = value.substring(1, value.length - 1);
  }

  return newValue;
};

// This is in order of the csv column.
export const PlateListCell = {
  KEYWORD: 'keyword',
  LABWARE_ID_NEST_1: 'labwareId1',
  LABWARE_ID_NEST_2: 'labwareId2',
  LABWARE_ID_NEST_3: 'labwareId3',
  LABWARE_ID_NEST_4: 'labwareId4',
  LABWARE_ID_NEST_5: 'labwareId5',
  LABWARE_ID_NEST_6: 'labwareId6',
  LABWARE_DESCRIPTION_NEST_1: 'labwareDesc1',
  LABWARE_DESCRIPTION_NEST_2: 'labwareDesc2',
  LABWARE_DESCRIPTION_NEST_3: 'labwareDesc3',
  LABWARE_DESCRIPTION_NEST_4: 'labwareDesc4',
  LABWARE_DESCRIPTION_NEST_5: 'labwareDesc5',
  LABWARE_DESCRIPTION_NEST_6: 'labwareDesc6',
  LABWARE_BARCODE_NEST_1: 'labwareBarcode1',
  LABWARE_BARCODE_NEST_2: 'labwareBarcode2',
  LABWARE_BARCODE_NEST_3: 'labwareBarcode3',
  LABWARE_BARCODE_NEST_4: 'labwareBarcode4',
  LABWARE_BARCODE_NEST_5: 'labwareBarcode5',
  LABWARE_BARCODE_NEST_6: 'labwareBarcode6',
  TRAY_TYPE: 'trayType',
};

export const PLATE_LIST_CELL_KEY = Object.values(PlateListCell);

// This is in order of the csv column.
export const CsvCellKeysEnum = {
  TYPE: 'type',
  LOCATION: 'location',
  ROW_TIP_COUNT: 'rowTipCount',
  COLUMN_TIP_COUNT: 'columnTipCount',
  ROW: 'row',
  COLUMN: 'column',
  VOLUME: 'volume',
  DELAY_TIME: 'delayTime',
  IS_IGNORED: 'isIgnored',
  TIP_POSITION: 'tipPosition',
  MIXING_CYCLE: 'mixingCycle',
  MIXING_VOLUME: 'mixingVolume',
  MIXING_POSITION_ASPIRATE: 'mixingPositionAspirate',
  SPEED: 'speed',
  RETRACT_SPEED: 'retractSpeed',
  MIXING_SPEED: 'mixingSpeed',
  PRECISION_DISPENSE: 'precisionDispense',
  DISPENSE_AT_WELL_SIDE: 'dispenseAtWellSide',
  TIP_TOUCH_OFF: 'tipTouchOff',
  TIP_TOUCH_OFF_DELAY: 'tipTouchOffDelay',
  MESSAGE: 'message',
  ID: 'ID',
  IS_SIMPLE_TRANSFER: 'isSimpleTransfer',
  CARD_ID: 'cardID',
  CARD_NAME: 'cardName',
  CHANGE_TIP: 'changeTip',
  GROUP_ID: 'groupID',
  GROUP_NAME: 'groupName',
  LABWARE_INDEX: 'labwareIndex',
  MIXING_POSITION_DISPENSE: 'mixingPositionDispense',
  TIP_X_POSITION_OFFSET: 'tipXPositionOffset',
  TIP_Y_POSITION_OFFSET: 'tipYPositionOffset',
  TIP_TOUCH_OFF_HEIGHT: 'tipTouchOffHeight',
  TIP_TOUCH_OFF_X_DIRECTION: 'tipTouchOffDirectionX',
  TIP_TOUCH_OFF_Y_DIRECTION: 'tipTouchOffDirectionY',
};

export const CSV_CELL_KEYS = Object.values(CsvCellKeysEnum);

const csvCellKeysForAllTypeOfTask = [
  CsvCellKeysEnum.TYPE,
  CsvCellKeysEnum.ID,
  CsvCellKeysEnum.IS_SIMPLE_TRANSFER,
  CsvCellKeysEnum.CARD_ID,
  CsvCellKeysEnum.CARD_NAME,
  CsvCellKeysEnum.GROUP_ID,
  CsvCellKeysEnum.GROUP_NAME,
  CsvCellKeysEnum.IS_IGNORED,
  CsvCellKeysEnum.MESSAGE,
];

const csvCellKeysForPickTip = [
  CsvCellKeysEnum.LOCATION,
  CsvCellKeysEnum.ROW_TIP_COUNT,
  CsvCellKeysEnum.COLUMN_TIP_COUNT,
  ...csvCellKeysForAllTypeOfTask,
];

const csvCellKeysForAspirate = Object.values(CsvCellKeysEnum).filter(
  (e) =>
    e !== CsvCellKeysEnum.DELAY_TIME &&
    e !== CsvCellKeysEnum.PRECISION_DISPENSE &&
    e !== CsvCellKeysEnum.DISPENSE_AT_WELL_SIDE &&
    e !== CsvCellKeysEnum.DELAY_TIME &&
    e !== CsvCellKeysEnum.CHANGE_TIP,
);

const csvCellKeysForDispense = Object.values(CsvCellKeysEnum).filter(
  (e) => e !== CsvCellKeysEnum.DELAY_TIME && e !== CsvCellKeysEnum.CHANGE_TIP,
);

const csvCellKeysForEjectTip = [
  CsvCellKeysEnum.CHANGE_TIP,
  CsvCellKeysEnum.ROW_TIP_COUNT,
  CsvCellKeysEnum.COLUMN_TIP_COUNT,
  CsvCellKeysEnum.LOCATION,
  ...csvCellKeysForAllTypeOfTask,
];

const csvCellKeysForDelay = [CsvCellKeysEnum.DELAY_TIME, ...csvCellKeysForAllTypeOfTask];

const csvCellKeysForUserConfirmation = [...csvCellKeysForAllTypeOfTask];

const csvCellKeysForAirGap = [
  CsvCellKeysEnum.VOLUME,
  CsvCellKeysEnum.TIP_POSITION,
  CsvCellKeysEnum.SPEED,
  CsvCellKeysEnum.RETRACT_SPEED,
  CsvCellKeysEnum.LOCATION,
  ...csvCellKeysForAllTypeOfTask,
];

const csvCellKeysForEnableHumidifier = [
  CsvCellKeysEnum.DELAY_TIME,
  CsvCellKeysEnum.VOLUME,
  CsvCellKeysEnum.CARD_ID,
  CsvCellKeysEnum.CARD_NAME,
  CsvCellKeysEnum.TYPE,
  CsvCellKeysEnum.ID,
];

export const ALLOWED_EMPTY_VALUE = [
  CsvCellKeysEnum.ID,
  CsvCellKeysEnum.CARD_ID,
  CsvCellKeysEnum.CARD_NAME,
  CsvCellKeysEnum.GROUP_NAME,
  CsvCellKeysEnum.IS_IGNORED,
  CsvCellKeysEnum.TIP_TOUCH_OFF_DELAY,
  CsvCellKeysEnum.MIXING_CYCLE,
  CsvCellKeysEnum.MIXING_VOLUME,
  CsvCellKeysEnum.MIXING_POSITION_DISPENSE,
  CsvCellKeysEnum.LOCATION,
];

export const isIgnoredCell = (key, taskType) => {
  switch (taskType) {
    case TaskType.PICK_TIP:
      return !csvCellKeysForPickTip.includes(key);
    case TaskType.ASPIRATE:
      return !csvCellKeysForAspirate.includes(key);
    case TaskType.DISPENSE:
      return !csvCellKeysForDispense.includes(key);
    case TaskType.EJECT_TIP:
      return !csvCellKeysForEjectTip.includes(key);
    case TaskType.DELAY:
      return !csvCellKeysForDelay.includes(key);
    case TaskType.USER_CONFIRMATION:
    case TaskType.USER_CONFIRMATION_EJECT:
      return !csvCellKeysForUserConfirmation.includes(key);
    case TaskType.AIR_GAP:
      return !csvCellKeysForAirGap.includes(key);
    case TaskType.ENABLE_HUMIDIFIER:
      return !csvCellKeysForEnableHumidifier.includes(key);
    default:
      return false;
  }
};

export const extractValueInPlateListRow = (row, cellKey) => {
  const index = PLATE_LIST_CELL_KEY.findIndex((cell) => cellKey === cell);
  const value = row[index];

  return dequote(value);
};
